import React, { useEffect, useRef, useState } from "react";
import {
  AttachmentSection,
  Button,
  DocumentsList,
  FormFieldSet,
  Modal,
  PageHeader,
  PageTitle,
  showToast,
  StatusTags,
  TableAdv,
  useFormHandler,
} from "../../../../components";
import { documentTypeOptions } from "../../../../assets/data/projectData";
import { EmploymentType, RecordStatus } from "../../../../assets/data/enumData";
import { v4 as uuidv4 } from "uuid";
import { useDispatch, useSelector } from "react-redux";
import { useLoginUser } from "../../../../hooks/useLoginUser";
import {
  getVendorOneStart,
  updateVendorStart,
} from "../../../../redux/slices/vendor/vendorSlice";
import useDropdownData from "../../../../hooks/useDropdownData";
import { uploadStart } from "../../../../redux/slices/universal/fileUploadSlice";
import { addDocumentStart } from "../../../../redux/slices/universal/documentsSlice";
import { useNavigate } from "react-router-dom";
import { dateFormator, mapTableRows } from "../../../../utils";
import {
  clearDocuments,
  getAllDocumentsStart,
} from "../../../../redux/slices/document/documentSlice";
import { formatWords2 } from "../../../../utils/stringUtils";
import { p } from "framer-motion/client";

const Documents = ({ setActiveTab, isEditable, editVendor = "", vendorId }) => {
  const navigate = useNavigate();
  const [dropdownSource, setDropdownSource] = useState("placements");
  const containerRef = useRef(null);
  const dispatch = useDispatch();
  const [docs, setDocs] = useState([]);
  const { userData: loginUserData } = useLoginUser();
  const organizationId = loginUserData?.organizationId.uiid;
  const loginUserUiid = loginUserData?.uiid;
  const vendorProfileUiid = useSelector(
    (state) => state.vendor.vendorProfileUiid
  );
  const vendorDetails = useSelector(
    (state) => state.vendor.currentVendor.vendorDetails
  );
  const documents = useSelector((state) => state.documents.documents) || [];

  const [selectedDocuments, setSelectedDocuments] = useState([]);

  const { formData, errors, handleChange, validateAllFields, setFormData } =
    useFormHandler(
      {
        documentType: "",
        selectPlacement: [],
        attachments: [
          {
            id: uuidv4(),
            attachmentName: "",
            attachmentComments: "",
            documentStatus: "",
            expiryDate: "",
            chooseFiles: [],
          },
        ],
      },
      {
        // documentType: { type: "text", required: true },
        attachments: [
          {
              // attachmentName: {
              //   type: "text",
              //   required: true,
              //   minLength: 3,
              // },
            chooseFiles: {
              type: "file",
              // required: true,
            },
          },
        ],
      }
    );
  useEffect(() => {
    if (vendorProfileUiid) {
      dispatch(
        getVendorOneStart({
          vendorUiid: vendorProfileUiid,
          retrieve: `documents`,
          ref: "DocPlacement",
        })
      );
      const filter = {
        "parent.vendor": { type: "NONE", value: vendorProfileUiid },
        // docType: {
        //   type: "EXCLUDE",
        //   value: [
        //     "Passport",
        //     "I94",
        //     "Everify",
        //     "certified LCA",
        //     "online Paper",
        //     "Visa",
        //   ],
        // },
      };
      dispatch(
        getAllDocumentsStart({
          filter,
        })
      );
    }
    return () => {
      dispatch(clearDocuments());
    };
  }, [vendorId]);
  // useEffect(() => {
  //   console.log("getting documents from store", vendorDetails?.documents);
  //   let docFiles = vendorDetails?.documents?.flatMap((doc) =>
  //     doc.list?.map((obj) => ({ ...obj, employeeId: doc.placement }))
  //   );
  //   setDocs(docFiles);
  //   console.log("doc chooseFiles", docFiles);
  // }, [vendorDetails]);

  //working
  // useEffect(() => {
  //   if (vendorProfileUiid) {
  //     const input = vendorDetails?.documents || [];

  //     const result = [];
  //     const seen = new Set();

  //     input.forEach((group) => {
  //       const placements = group.placement || [];

  //       group.list.forEach((item) => {
  //         const docType = item.docType;

  //         item.file.forEach((f) => {
  //           f.keys.forEach((k) => {
  //             placements.forEach((p) => {
  //               const uniqueId = `${p}-${docType}-${f.name}-${k}`;
  //               if (!seen.has(uniqueId)) {
  //                 result.push({
  //                   placement: p,
  //                   docType,
  //                   name: docType + "-" + f.name + "-" + p,
  //                   filePath: k,
  //                 });
  //                 seen.add(uniqueId);
  //               }
  //             });
  //           });
  //         });
  //       });
  //     });

  //     setDocs(result);
  //     console.log(result);
  //   }
  // }, [vendorDetails]);

  //testing
  useEffect(() => {
    if (vendorDetails && documents) {
      const input = vendorDetails?.documents || [];

      const result = [];
      const seen = new Set();

      input.forEach((group) => {
        const placements = group.placement || [];
        const documentIds = group.list || [];

        // For each placement, combine with each document
        placements.forEach((placement) => {
          documentIds.forEach((docId) => {
            // Find the matching document from the documents array
            const documentData = documents.find((doc) => doc.uiid === docId);

            if (documentData) {
              // Process each file in the document
              documentData.file.forEach((file) => {
                // Create unique ID based on placement, document, and file
                const uniqueId = `${placement.uiid}-${docId}-${file.name}`;

                if (!seen.has(uniqueId)) {
                  result.push({
                    // Employee details from placement
                    employeeName: [placement.employeeId?.firstName, placement.employeeId?.lastName].filter(Boolean).join(" ") || null, // This field doesn't exist in the data structure
                    employeeUiid: placement.employeeId?.uiid || " - ",
                    employeeType: placement.employeeId?.employementType || "-",
                    employeeId: placement.employeeId?.uiid || "-",

                    // Job details from placement
                    jobTitle: placement.jobInfo?.jobTitle,
                    jobCode: placement.jobInfo?.jobCode,
                    startDate: placement.jobInfo?.startDate,

                    // Document details from documents array
                    type: formatWords2(documentData.docType),
                    title: file.name,
                    expiryDate: file.expiry,
                    status: file.status,
                    keys: file.keys, // This will be an array of file paths
                  });
                  seen.add(uniqueId);
                }
              });
            }
          });
        });
      });

      setDocs(result);
    }
  }, [vendorDetails, documents]);
  const {
    data: allSelectPlacementListOptions,
    searchValue: allSelectPlacementSearch,
    handleSearch: handleSelectPlacementSearch,
    resetSearch: resetAllSelectPlacementSearch,
    handleScroll: handleAllSelectPlacementScroll,
  } = useDropdownData(
    "vendorPlacements",
    10,
    {},
    {
      //for tetsing show all employee
      //if wnat for spcific cliuents paceement open this comment👇
      entityId: vendorProfileUiid,
      //to test only employees
      // entityId: 1003,
      entityType: "Vendor",
    }
  );

  // const {
  //   data: allSelectEmployeeListOptions,
  //   searchValue: allSelectEmployeeSearch,
  //   handleSearch: handleSelectEmployeeSearch,
  //   resetSearch: resetAllSelectEmployeeSearch,
  //   handleScroll: handleAllSelectEmployeeScroll,
  // } = useDropdownData("employees", 10, {}, {});

  useEffect(() => {
    if (allSelectPlacementListOptions?.length > 0) {
      setDropdownSource("placements");
    } else {
      setDropdownSource("employees");
    }
  }, [allSelectPlacementListOptions]);
  const dropdownOptions =
    dropdownSource === "placements"
      ? {
          options: allSelectPlacementListOptions,
          search: allSelectPlacementSearch,
          onSearch: handleSelectPlacementSearch,
          onReset: resetAllSelectPlacementSearch,
          onScroll: handleAllSelectPlacementScroll,
        }
      : {
          // options: allSelectEmployeeListOptions,
          // search: allSelectEmployeeSearch,
          // onSearch: handleSelectEmployeeSearch,
          // onReset: resetAllSelectEmployeeSearch,
          // onScroll: handleAllSelectEmployeeScroll,
        };
  const handleFileChange = (id, selectedFiles) => {
    const fileArray = Array.from(selectedFiles);
    setFormData((prevData) => ({
      ...prevData,
      attachments: prevData.attachments.map((doc) =>
        doc.id === id ? { ...doc, chooseFiles: fileArray } : doc
      ),
    }));
  };

  const addDocumentAfter = (index) => {
    const newDocument = {
      id: Date.now(),
      attachmentName: "",
      attachmentComments: "",
      documentStatus: "",
      expiryDate: "",
      chooseFiles: [],
    };

    setFormData((prevData) => {
      const updatedDocs = [...prevData.attachments];
      updatedDocs.splice(index + 1, 0, newDocument);
      return { ...prevData, attachments: updatedDocs };
    });
  };

  const removeDocument = (id) => {
    setFormData((prevData) => ({
      ...prevData,
      documents: prevData.attachments.filter((doc) => doc.id !== id),
    }));
  };

  const handleDocumentChange = (id, field, value) => {
    setFormData((prevData) => ({
      ...prevData,
      documents: prevData.attachments.map((doc) =>
        doc.id === id ? { ...doc, [field]: value } : doc
      ),
    }));
  };

  const handleSave = () => {
    const hasFiles = formData.attachments.some(
      (att) => att.chooseFiles && att.chooseFiles.length > 0
    );
    if (!hasFiles) {
      navigate("/vendor");
      return;
    }
    const isValid = validateAllFields();
    if (isValid) {
      const cleanAttachments = formData.attachments.filter(
        (att) =>
          att.attachmentName.trim() !== "" ||
          att.attachmentComments.trim() !== "" ||
          att.documentStatus.trim() !== "" ||
          att.expiryDate !== "" ||
          (att.chooseFiles && att.chooseFiles.length > 0)
      );
      formData;
      dispatch(
        updateVendorStart({
          uiid: vendorProfileUiid,
          coll: "Vendor",
          tPath: "documents",
          payload: [
            {
              type: "PUSH",
              value: {
                documents: {
                  // placement: formData.selectPlacement || undefined,
                  placement:
                    formData.selectPlacement?.map((item) =>
                      Number(item?.split(":")[0])
                    ) || undefined,
                },
              },
            },
          ],
          onSuccess: async (updateRes) => {
            console.log("Client updated, patchId:", updateRes.targetPatchId);

            if (cleanAttachments.length > 0) {
              dispatch(
                uploadStart({
                  uploadType: "multiple",
                  field: "doc",
                  uiid: vendorProfileUiid,
                  entity: "vendors",
                  category: "documents",
                  coll: "Vendor",
                  doc: cleanAttachments.flatMap((doc) =>
                    doc.chooseFiles.map((file) => {
                      file.id = doc.id;
                      return file;
                    })
                  ),
                  onSuccess: async (fileData) => {
                    dispatch(
                      addDocumentStart({
                        coll: "Document",
                        refColl: "Vendor",
                        refId: vendorProfileUiid,
                        refField: `documents.$[elem].list`,
                        refPatchId: updateRes.targetPatchId,
                        isRefFieldArray: true,
                        payload: {
                          addedBy: loginUserUiid,
                          attachments: [
                            {
                              addedBy: loginUserUiid,
                              parent: {
                                vendor: vendorProfileUiid,
                                placement: formData.selectPlacement?.map(
                                  (item) => Number(item?.split(":")[0])
                                ),
                              },
                              docType: formData.documentType.value,
                              ref: {
                                id: vendorProfileUiid,
                                entity: "Vendor",
                                path: `documents.${updateRes.targetPatchId}.list`,
                              },
                              file: formData.attachments.map((obj) => ({
                                // id: obj.id,
                                name: obj.attachmentName,
                                comments: obj.attachmentComments,
                                status: obj.documentStatus,
                                expiry: obj.expiryDate,
                                // addedBy: loginUserUiid,
                                keys: fileData.map(
                                  (file) =>
                                    file.fileRefId === obj.id && file.key
                                ),
                              })),
                            },
                          ],
                        },
                        onSuccess: (docRes) => {
                          console.log("Document added successfully:", docRes);
                          dispatch(
                            getVendorOneStart({
                              vendorUiid: vendorProfileUiid,
                              retrieve: `documents`,
                              ref: "DocPlacement",
                            })
                          );
                          navigate("/vendor");
                        },
                      })
                    );
                  },
                })
              );
            }
          },
        })
      );

      console.log("Form submitted successfully: addclient", formData);
    } else {
      console.log("Please fix the errors before submitting.");
      showToast("Please fill all the required feilds before saving", "error", 3000);
    }
  };

  const handleBack = () => {
    setTimeout(() => {
      setActiveTab((prev) => prev - 1);
    }, 500);
  };
  ///////////////////////////////////////////////////
  //handel Attachment Error
  ///////////////////////////////////////////////////

  const getAttachmentError = (index, field) => {
    return errors?.attachments?.[index]?.[field] || "";
  };
  ///////////////////////////////////////////////////
  //handel Attachment Error end
  ///////////////////////////////////////////////////

  const columns = [
    {
      key: "employeeName",
      label: "Consultant Name",
    },

    {
      key: "employeeId",
      label: "Consultant Code",
    },
    {
      key: "jobTitle",
      label: "Placement",
    },
    {
      key: "jobCode",
      label: "Job Code",
    },
    {
      key: "type",
      label: "Document Type",
    },
    {
      key: "title",
      label: "Title",
    },
    {
      key: "startDate",
      label: "Start Date",
      render: (row) => dateFormator(row.startDate, "month-day-year"),
    },
    {
      key: "expiryDate",
      label: "End Date",
      render: (row) => dateFormator(row.endDate, "month-day-year"),
    },
    {
      key: "status",
      label: "PO Number",
      render: (row) => (
        <StatusTags tag={row.status == 1 ? "Active" : "Inactive"} />
      ),
    },

    {
      key: "keys",
      label: "Document",
      render: (row) => {
        const updateFiles = (row?.keys || []).map((key) => ({
          filePath: key,
          name: row?.type || "client documents",
        }));
        return (
          <div className="flex items-center">
            <Button
              variant="text"
              icon={"download"}
              color="info"
              size="sm"
              title={row.document}
              iconPosition="after"
              onClick={() => setSelectedDocuments(updateFiles)}
              disabled={updateFiles.length === 0}
            />
          </div>
        );
      },
    },
  ];

  const mappedRows = mapTableRows(docs, columns);
  return (
    <div className="flex flex-col overflow-auto rounded w-full h-screen px-8 py-3">
      <div className="mb-8">
        <PageHeader
          Section={
            <div className="flex">
              <PageTitle title={"Documents"} icon={"badge"} tag="h5" />
            </div>
          }
          RightSection={
            <>
              {isEditable && (
                <>
                  <Button
                    title="Back"
                    size="sm"
                    icon={"arrow_left_alt"}
                    onClick={handleBack}
                  />
                  <Button title="Save" size="sm" onClick={handleSave} />
                </>
              )}
            </>
          }
        />
      </div>

      <div className="grid xs:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-6 max-w-7xl">
        <FormFieldSet
          type="documentTypes"
          title={"Document Type"}
          placeholder="Select"
          value={formData.documentType}
          onChange={(value) => handleChange("documentType", value)}
          error={errors.documentType}
          options={documentTypeOptions}
          showButton
          showSearch
          required
          disabled={!isEditable}
        />
        <FormFieldSet
          type="select"
          multiple
          title={"Select Placement"}
          placeholder="Select"
          // options={EmploymentType}
          options={
            dropdownOptions.options?.filter((placement) => {
              const endDate = new Date(placement?.jobInfo?.endDate);
              const today = new Date();
              return !placement?.jobInfo?.endDate || endDate >= today;
            }) || []
          }
          keyname="employees"
          value={formData.selectPlacement}
          onChange={(value) => handleChange("selectPlacement", value)}
          error={errors.selectPlacement}
          // showButton
          showSearch
          searchValue={dropdownOptions.search}
          onClose={dropdownOptions.onReset}
          refData={containerRef}
          onSearch={dropdownOptions.onSearch}
          handleScroll={() => dropdownOptions.onScroll(containerRef)}
          disabled={!isEditable}
        />
      </div>
      <div className=" mt-6">
        <PageHeader
          Section={
            <div className="flex">
              <PageTitle title={"Documents List"} tag="h6" />
            </div>
          }
        />

        <AttachmentSection
          attachments={formData.attachments}
          onChange={(value) => handleChange("attachments", value)}
          getAttachmentError={getAttachmentError}
          showNameField={true}
          showCommentsField={true}
          showDocumentStatusField={true}
          showExpiryDateField={true}
          maxAttachments={100}
        />
        {/* <DocumentsList data={docs || []} /> */}
        {/* {docs.map((doc) => (
          <DocumentsList data={doc || []} type="inner" />
        ))} */}
      </div>
      <div className="mt-4">
        <TableAdv tableId={`vendors_documents`} columns={columns} rows={mappedRows} hideToolBar />
      </div>
      <Modal
        isOpen={selectedDocuments.length > 0}
        onClose={() => setSelectedDocuments([])}
        width="max-w-2xl"
        title={"Document Details"}
      >
        <DocumentsList data={selectedDocuments} />
      </Modal>
    </div>
  );
};

export default Documents;
